import { render } from "./CountriesView.vue?vue&type=template&id=c8a58af0"
import script from "./CountriesView.vue?vue&type=script&lang=js"
export * from "./CountriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__